import api from "../../js/apiClient";

export const actions = {
  async loadFavourites({ commit }) {
    commit("setError", null);
    commit("setIsLoading", true);

    try {
      const items = await api.favourites.index();
      commit("hydrateFavourites", items);
    } catch (err) {
      commit("setError", err.message);
    } finally {
      commit("setIsLoading", false);
    }
  },

  async addFavourite({ commit }, item) {
    commit("addFavourite", item);
    try {
      await api.favourites.addItem(item);
    } catch {
      // Remove favourite if request fails
      commit("removeFavourite", item);
    }
  },

  async removeFavourite({ commit }, item) {
    commit("removeFavourite", item);
    try {
      await api.favourites.removeItem(item);
    } catch {
      // Reinstate favourite if request fails
      commit("addFavourite", item);
    }
  },
};

export const mutations = {
  addFavourite(state, payload) {
    state.items.push(payload);
  },

  removeFavourite(state, payload) {
    const index = state.items.findIndex((item) => item.id === payload.id);

    if (index === -1) throw Error("Item not found in favourites");

    state.items.splice(index, 1);
  },

  hydrateFavourites(state, payload) {
    // eslint-disable-next-line
    state.items = payload;
  },

  setError(state, payload) {
    // eslint-disable-next-line
    state.error = payload;
  },

  setIsLoading(state, payload) {
    // eslint-disable-next-line
    state.isLoading = payload;
  },
};

export default {
  namespaced: true,

  state: {
    error: null,
    isLoading: false,
    items: [],
  },

  actions,

  mutations,
};
